module.exports = __webpack_public_path__ + "static/media/SupportIconInactive.dd67fff8.svg";